import { render, staticRenderFns } from "./PromotionForm.vue?vue&type=template&id=0c3680e6&"
import script from "./PromotionForm.vue?vue&type=script&lang=ts&"
export * from "./PromotionForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports